var exports = {
  "M": "x7be19a29--f92d62--page",
};

module.exports = exports;
